import {
  BarsArrowUpIcon,
  MagnifyingGlassIcon,
} from "@heroicons/react/16/solid";

type DatalistEntry = {
  key: string;
  label: string;
};

type FilterBarProps = {
  value: string;
  onChange: (value: string) => void;
  datalistEntries?: DatalistEntry[];
  showSortButton?: boolean;
};

export default function FilterBar({
  value,
  onChange,
  datalistEntries,
  showSortButton = false,
}: FilterBarProps) {
  return (
    <div className="my-12 flex">
      <div
        className={`${showSortButton ? "-mr-px" : ""} grid grow grid-cols-1 focus-within:relative`}
      >
        <input
          list="filter-names"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          type="text"
          placeholder=""
          className={`col-start-1 row-start-1 block w-full ${showSortButton ? "rounded-l-md" : "rounded-md"} bg-white py-4 pr-3 pl-10 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:pl-9 sm:text-sm/6`}
        />
        <MagnifyingGlassIcon
          aria-hidden="true"
          className="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-400 sm:size-4"
        />
        {datalistEntries && (
          <datalist id="filter-names">
            {datalistEntries.map((entry) => (
              <option key={entry.key} value={entry.label} />
            ))}
          </datalist>
        )}
      </div>
      {showSortButton && (
        <button
          type="button"
          className="flex shrink-0 items-center gap-x-1.5 rounded-r-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 outline-1 -outline-offset-1 outline-gray-300 hover:bg-gray-50 focus:relative focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600"
        >
          <BarsArrowUpIcon
            aria-hidden="true"
            className="-ml-0.5 size-4 text-gray-400"
          />
          Sort
        </button>
      )}
    </div>
  );
}
